import React, { useEffect } from "react";
import WebFont from "webfontloader";
export default function FontUploader() {
  WebFont.load({
    custom: {
      families: ["Roboto", "roboto", "sans-serif"],
    },
  });
}
